module.exports = __webpack_public_path__ + "static/media/icons8-google-photos.2e840203.svg";